import { getFileExtensionByName } from '@iris/common/utils/file.utils';
import { IrisDMSTagI } from './IrisDMSTag';

export enum FileHistoryActionType {
  Upload = 'label.dms.Upload',
  Lock = 'label.dms.Lock',
  Unlock = 'label.dms.Unlock',
  AddLinkToFile = 'label.dms.AddLinkToFile',
  InProgressChange = 'label.dms.InProgressChange',
  Rename = 'label.dms.Rename',
  // for new dms
  Add = 'dms.action.Add',
  Edit = 'dms.action.Edit',
  LinkAdd = 'dms.action.LinkAdd',
  LinkRemove = 'dms.action.LinkRemove',
  RenameFile = 'dms.action.Rename',
  MoveFile = 'dms.action.Move',
  CopyFile = 'dms.action.Copy',
  FormAdd = 'dms.action.FormAdd',
  FormDelete = 'dms.action.FormDelete',
}

export enum FileActionType {
  Rename = 'Rename',
  Download = 'Download',
  Send = 'Send',
  Preview = 'Preview',
  Edit = 'Edit',
  EditOfficeFile = 'EditOfficeFile',
  Move = 'Move',
  Remove = 'Remove',
}

export enum FileUploadState {
  Uploading = 'Uploading',
  Completed = 'Completed',
  Canceled = 'Canceled',
  Error = 'Error',
}

export const FileExtensions = {
  email: ['msg', 'eml'],
};

export const OFFICE_MIME_TYPES = {
  word: [
    'application/msword',
    'application/rtf',
    'application/vnd.oasis.opendocument.text',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
    'application/vnd.ms-word.template.macroenabled.12',
    'application/vnd.ms-word.document.macroenabled.12',
    'application/vnd.oasis.opendocument.text-master',
    'application/vnd.oasis.opendocument.text-template',
    'application/vnd.sun.xml.writer',
    'application/vnd.sun.xml.writer.global',
  ],
  excel: [
    'application/vnd.ms-excel',
    'application/vnd.ms-excel.sheet.binary.macroenabled.12',
    'application/vnd.ms-excel.sheet.macroenabled.12',
    'application/vnd.ms-excel.template.macroenabled.12',
    'application/vnd.oasis.opendocument.spreadsheet',
    'application/vnd.oasis.opendocument.spreadsheet-template',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
    'application/vnd.sun.xml.calc',
    'application/vnd.sun.xml.calc.template',
  ],
  powerpoint: [
    'application/vnd.ms-powerpoint',
    'application/vnd.ms-powerpoint.addin.macroenabled.12',
    'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
    'application/vnd.ms-powerpoint.slide.macroenabled.12',
    'application/vnd.ms-powerpoint.slide.macroenabled.12',
    'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
    'application/vnd.ms-powerpoint.template.macroEnabled.12',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.openxmlformats-officedocument.presentationml.slide',
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
    'application/vnd.openxmlformats-officedocument.presentationml.template',
    'application/vnd.sun.xml.impress',
    'application/vnd.sun.xml.impress.template',
  ],
  onenote: [
    'application/onenote',
  ],
  visio: [
    'application/vnd.ms-visio.drawing',
    'application/vnd.ms-visio.viewer',
    'application/vnd.visio',
    'application/x-ms-vsto',
  ],
};

export const LEGACY_OFFICE_MIME_TYPES = [
  'application/msword',
  'application/vnd.ms-excel',
  'application/vnd.ms-powerpoint',
];

export const LEGACY_EXCEL_EXTENSIONS = ['xls', 'xlt', 'xlm'];
export const EXCEL_EXTENSIONS = ['ods', 'xla', 'xlam', 'xll', 'xlsb', 'xlsm', 'xlsx', 'xltx', 'xlw'];

export const LEGACY_POWERPOINT_EXTENSIONS = ['ppt', 'pot', 'pps'];
export const POWERPOINT_EXTENSIONS = ['odp', 'potm', 'potx', 'ppam', 'ppsm', 'ppsx', 'pptm', 'pptx', 'sldm', 'sldx'];

export const LEGACY_WORD_EXTENSIONS = ['doc', 'dot', 'wbk'];
export const WORD_EXTENSIONS = ['docb', 'docm', 'docx', 'dotm', 'dotx', 'odt', 'rtf'];

export const LEGACY_TYPE = 'Legacy';

export const OFFICE_FILE_TYPE_ICON = {
  excel: 'https://c1-excel-15.cdn.office.net/x/_layouts/resources/FavIcon_Excel.ico',
  excelLegacy: 'https://c1-excel-15.cdn.office.net/x/_layouts/resources/FavIcon_Excel.ico',
  onenote: 'https://c1-onenote-15.cdn.office.net/o/resources/1033/FavIcon_OneNote.ico',
  powerpoint: 'https://c1-powerpoint-15.cdn.office.net/p/resources/1033/FavIcon_Ppt.ico',
  powerpointLegacy: 'https://c1-powerpoint-15.cdn.office.net/p/resources/1033/FavIcon_Ppt.ico',
  visio: 'https://c1-visio-15.cdn.office.net/v/resources/1033/FavIcon_Visio.ico',
  word: 'https://c1-word-view-15.cdn.office.net/wv/resources/1033/FavIcon_Word.ico',
  wordLegacy: 'https://c1-word-view-15.cdn.office.net/wv/resources/1033/FavIcon_Word.ico',
  wopitest: 'https://c1-word-view-15.cdn.office.net/wv/resources/1033/FavIcon_Word.ico',
};

export const OFFICE_EDIT_URL_TEMPLATE = {
  excel: 'https://excel.officeapps.live.com/x/_layouts/xlviewerinternal.aspx?edit=1&new=1&',
  excelLegacy: 'https://excel.officeapps.live.com/x/_layouts/xlviewerinternal.aspx?',
  onenote: 'https://onenote.officeapps.live.com/o/onenoteframe.aspx?edit=1&new=1&',
  powerpoint: 'https://powerpoint.officeapps.live.com/p/PowerPointFrame.aspx?PowerPointView=EditView&New=1&',
  powerpointLegacy: 'https://powerpoint.officeapps.live.com/p/PowerPointFrame.aspx?',
  visio: 'https://visio.officeapps.live.com/v/VisioFrame.aspx?VisioView=EditView&New=1&',
  word: 'https://word-edit.officeapps.live.com/we/wordeditorframe.aspx?new=1&',
  wordLegacy: 'https://word-view.officeapps.live.com/wv/wordviewerframe.aspx?',
  wopitest: 'https://onenote.officeapps.live.com/hosting/WopiTestFrame.aspx?',
};

export interface FileHistoryItem {
  action: FileHistoryActionType;
  args: string[];
  comment: string;
  filename: string;
  id: string;
  number?: number;
  size?: number;
  updatedBy: string;
  updatedById: number;
  updatedOn: string;
}

export type FileVersionByNameI = Record<string, number>;

export interface IrisDMSUploadingFile {
  name: string;
  state: FileUploadState;
  folderId?: string;
  id?: string;
}

export interface DmsSearchResult {
  searchHits: IrisDMSFileI[];
  offset: number;
}

export interface DmsPhotoMetadataI {
  creator: string;
  dateCreated: string;
  gpsLatitude: number;
  gpsLongitude: number;
}

export interface IrisDmsFileFormInfoI {
  templateId: number;
  documentId: string;
}

export interface IrisDmsEmailMetadataI {
  dateReceived: Date;
  dateSend: Date;
  recipients: string[];
  sender: string;
  subject: string;
}

export interface IrisDMSFileI {
  name: string;
  id: string;
  parentId: string;
  createdOn: string;
  createdBy: number;
  mimeType: string;
  fileSize: number;
  size: number;
  isLocked: boolean;
  isOfficeEditingLocked: boolean;
  updatedOn: string;
  updatedBy: number;
  workflowId: number;
  workflowStateId: number;
  inProgressBy: number;
  markerId: number;
  layerId: number;
  path: string;
  contentLanguage: string[];
  ownerId: number;
  country: string;
  company: string;
  department: string;
  workflowState: string;
  history: FileHistoryItem[];
  attachments: IrisDMSFileI[];
  attachedIn: string[];
  tags: IrisDMSTagI[];
  originalName: string;
  originalPath: string;
  originalId: string;
  removedDate: string;
  thumbId: string;
  previewId: string;
  isFavorite: boolean;
  type: string;
  curUserId: number;
  description: string;
  isPreviewReady: boolean;
  photoMetadata?: DmsPhotoMetadataI;
  recordingTime: string;
  projectId?: number;
  mailMetadata?: IrisDmsEmailMetadataI;
  forms?: IrisDmsFileFormInfoI[];
  links?: string[];
  readonly hasLinks: boolean;
  readonly extension: string;
  readonly officeFileType: string;
  readonly officeFileIcon: string;
  readonly extensionFromFileName: string;
  composeWopiEditUrl(wopiSrc: string): string;
}

export class IrisDMSFile implements IrisDMSFileI {
  name: string = undefined;
  id: string = undefined;
  parentId: string = undefined;
  createdOn: string = undefined;
  createdBy: number = undefined;
  mimeType: string = undefined;
  fileSize: number = undefined;
  size: number = undefined;
  isLocked: boolean = undefined;
  isOfficeEditingLocked = false;
  updatedOn: string = undefined;
  updatedBy: number = undefined;
  workflowId: number = undefined;
  workflowStateId: number = undefined;
  inProgressBy: number = undefined;
  markerId: number = undefined;
  layerId: number = undefined;
  path: string = undefined;
  contentLanguage: string[] = [];
  ownerId: number = undefined;
  country: string = undefined;
  company: string = undefined;
  department: string = undefined;
  workflowState: string = undefined;
  history: FileHistoryItem[] = [];
  attachedIn: string[] = [];
  attachments: IrisDMSFileI[] = [];
  tags: IrisDMSTagI[] = [];
  originalName: string = undefined;
  originalPath: string = undefined;
  originalId: string = undefined;
  removedDate: string = undefined;
  thumbId: string = undefined;
  previewId: string = undefined;
  isFavorite: boolean = undefined;
  type: string = undefined;
  curUserId: number = undefined;
  description: string = undefined;
  isPreviewReady: boolean = undefined;
  photoMetadata?: DmsPhotoMetadataI = undefined;
  recordingTime: string = undefined;
  mailMetadata?: IrisDmsEmailMetadataI = undefined;
  forms?: IrisDmsFileFormInfoI[] = [];
  links?: string[] = [];

  constructor(params?: Partial<IrisDMSFileI>) {
    const newParams = { ...params };
    if (!!newParams && !!newParams.size) {
      newParams.fileSize = newParams.size;
    }

    if (params) {
      Object.keys(this).forEach((key) => {
        if (newParams[key] !== undefined) {
          this[key] = newParams[key];
        }
      });
    }
  }

  get extension(): string {
    return getFileExtensionByName(this.name);
  }

  get hasLinks(): boolean {
    return !!(this.links ?? []).length;
  }

  get officeFileType(): string {
    let fileType = '';

    if (this.mimeType) {
      fileType = Object.keys(OFFICE_MIME_TYPES).find(type => OFFICE_MIME_TYPES[type].includes(this.mimeType.toLowerCase()));
      if (LEGACY_OFFICE_MIME_TYPES.includes(this.mimeType.toLowerCase())) {
        fileType = fileType + LEGACY_TYPE;
      }
    }

    if (!fileType) {
      const fileExtension = this.extensionFromFileName;
      switch (true) {
        case LEGACY_EXCEL_EXTENSIONS.includes(fileExtension):
          return 'excel' + LEGACY_TYPE;
        case EXCEL_EXTENSIONS.includes(fileExtension):
          return 'excel';
        case LEGACY_POWERPOINT_EXTENSIONS.includes(fileExtension):
          return 'powerpoint' + LEGACY_TYPE;
        case POWERPOINT_EXTENSIONS.includes(fileExtension):
          return 'powerpoint';
        case LEGACY_WORD_EXTENSIONS.includes(fileExtension):
          return 'word' + LEGACY_TYPE;
        case WORD_EXTENSIONS.includes(fileExtension):
          return 'word';
        case 'wopitest' === fileExtension:
          return 'wopitest';
      }
    }

    return fileType;
  }

  get officeFileIcon(): string {
    return OFFICE_FILE_TYPE_ICON[this.officeFileType];
  }

  get extensionFromFileName(): string {
    return !!this.name && this.name.includes('.') ? this.name.split('.').pop().toLowerCase() : '';
  }

  composeWopiEditUrl(wopiUrl: string): string {
    const urlTemplate = OFFICE_EDIT_URL_TEMPLATE[this.officeFileType];
    if (!urlTemplate) {
      return null;
    }

    return `${urlTemplate}wopiSrc=${wopiUrl}`;
  }
}
